import React from 'react';
import { Select, Button } from 'antd';

const { Option } = Select;

const options = [
  {label: 'Swindled', value: 'swindled' },
  {label: 'Crime Junkie', value: 'crimejunkie'},
  {label: 'Morbid', value: 'morbid'},
  {label: 'RedHanded', value: 'redhanded'}
]

function Selected ({ width, setShowing }) {
  
  const handleSelect = (selection, change) => {
    setShowing(prevState => {
      return ({
        ...prevState,
        [selection]: change === 0 ? false : true,
      })
    })
  }

  return (
    <React.Fragment>
      <Select
        mode="tags"
        allowClear
        style={{ width: width }}
        placeholder="Select podcasts to show"
        options={options}
        defaultValue={'crimejunkie'}
        onSelect={(value) => handleSelect(value)}
        onDeselect={(value) => handleSelect(value, 0)}
        onClear={() => setShowing({})}
      />
    </React.Fragment>
 )
}

export default Selected;